import { ReactNode } from 'react'
import { Link } from 'react-router'

import { Participant } from '@/interfaces/Participant'
import { cn } from '@/lib/utils'

/** Jméno (nebo jiné údaje) odběratele či dodavatele jako odkaz na detail kontaktu. */
export const CounterpartyName = ({
  participant,
  fallback,
  className,
  children,
}: {
  participant: Pick<Participant, 'id' | 'name'> | null | undefined
  fallback?: string
  className?: string
  children?: ReactNode
}) =>
  participant?.id ? (
    // v klikatelném řádku tabulky nesmí klik otevřít i doklad
    <Link to={`/contact/${participant.id}`} onClick={(e) => e.stopPropagation()} className={cn('hover:underline', className)}>
      {children ?? participant.name}
    </Link>
  ) : (
    <>{children ?? participant?.name ?? fallback}</>
  )
